import { Row } from "antd";
import { ProviderIcon } from "../../ProviderIcon";
import { useCallback } from "react";

type ProviderProps = {
  isSelected: boolean;
  data: any;
  setSelectedItem: React.Dispatch<React.SetStateAction<any>>;
};

export const Provider = ({
  isSelected,
  data,
  setSelectedItem,
}: ProviderProps) => {
  const onClick = useCallback(
    () => setSelectedItem(data),
    [data, setSelectedItem],
  );

  return (
    <Row
      className={`provider-card pa-4 align-center logo-cursor ${isSelected ? "selected" : ""} mr-2`}
      onClick={onClick}
    >
      <ProviderIcon type={data.methodType} />
      <p className="my-0 ml-2 text w-500">{data.methodName}</p>
    </Row>
  );
};
